/**
 * 消息卡片组件
 * @author ritaxxu
 */
import React, { useState } from 'react'
import { Tag, Button } from 'antd'
import {
  IInnerMsgItem,
  InnerMsgLevel,
  InnerMsgReadStatus,
} from '@types'

interface MessageCardProps {
  message: IInnerMsgItem
  onClick: () => void
  onMarkAsRead: () => void
}

const MessageCard: React.FC<MessageCardProps> = ({ message, onClick, onMarkAsRead }) => {
  const [hovered, setHovered] = useState(false)

  const isUnread = message.readStatus === InnerMsgReadStatus.Unread
  const isImportant = message.level === InnerMsgLevel.Important

  return (
    <div
      className={`notification-card ${isUnread ? 'notification-card--unread' : ''} ${isImportant && isUnread ? 'notification-card--important' : ''}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={onClick}
    >
      <div className="notification-card-content">
        <div className="notification-card-title">{message.title}</div>
        <div className="notification-card-tags">
          {isImportant && <Tag color="red">🔴 重要</Tag>}
          {message.tags?.map((tag) => (
            <Tag key={tag} color="#f0f2f5" style={{ color: '#666' }}>{tag}</Tag>
          ))}
        </div>
        <div className="notification-card-time">{message.sentAt}</div>
      </div>

      {isImportant && isUnread ? (
        <Button
          type="primary"
          danger
          size="small"
          className="notification-card-mark-btn--important"
          onClick={(e) => {
            e.stopPropagation()
            onMarkAsRead()
          }}
        >
          标为已读
        </Button>
      ) : isUnread ? (
        <Button
          size="small"
          className="notification-card-mark-btn"
          style={{ visibility: hovered ? 'visible' : 'hidden' }}
          onClick={(e) => {
            e.stopPropagation()
            onMarkAsRead()
          }}
        >
          标为已读
        </Button>
      ) : null}
    </div>
  )
}

export default MessageCard
